/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { DateTime } from 'luxon'
import { FormattedMessage } from 'react-intl'
import { Badge } from '@mantine/core'

export type InvoiceStatusBadgeProps = {
  invoice: Invoice
}

function InvoiceStatusBadge (props: InvoiceStatusBadgeProps) {
  const { invoice } = props

  if (invoice.paid || invoice.paidAt) {
    return (
      <Badge color="green">
        <FormattedMessage
          id="paid"
          defaultMessage="Payée"
        />
      </Badge>
    )
  }
  if (DateTime.fromISO(invoice.dueAt).toJSDate() >= new Date()) {
    return (
      <Badge color="yellow">
        <FormattedMessage
          id="pending"
          defaultMessage="En attente"
        />
      </Badge>
    )
  }
  return (
    <Badge color="red">
      <FormattedMessage
        id="unpaid"
        defaultMessage="Impayée"
      />
    </Badge>
  )
}

export default InvoiceStatusBadge
